var map = {
	"./Bhagini/images/CardBankLogo.svg": [
		42303,
		2303
	],
	"./DMKJ/images/CardBankLogo.svg": [
		11741,
		1741
	],
	"./Deogiri/images/CardBankLogo.svg": [
		70928,
		928
	],
	"./JCOM/images/CardBankLogo.svg": [
		59050,
		9050
	],
	"./Mahesh/images/CardBankLogo.svg": [
		14493,
		4493
	],
	"./Samta/images/CardBankLogo.svg": [
		33675,
		3675
	],
	"./Ucob/images/CardBankLogo.svg": [
		17896,
		7896
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 47301;
module.exports = webpackAsyncContext;